export const assetClassValues = [
    "BANK_ACCOUNT",
    "FIXED_INCOME_FUND",
    "FX",
    "TERM_DEPOSIT",
];
const accountTypeValues = [
    "FIXED_INCOME_FUND",
    "FX",
    "SAVINGS",
    "TERM_DEPOSIT",
    "TRANSACTION",
];
const accountsGroupKindValues = [
    "ACCOUNT_TYPE",
    "ASSET_CLASS",
    "BUSINESS_ENTITY",
    "CURRENCY",
    "PROVIDER",
];
export const currencyValues = [
    "AUD",
    "CAD",
    "CNY",
    "EUR",
    "GBP",
    "HKD",
    "JPY",
    "NZD",
    "SGD",
    "USD",
    "MYR",
    "BRL",
    "CHF",
    "PHP",
    "SEK",
    "ZAR",
];
